import type { Middleware } from '@reduxjs/toolkit'
import { setZoneInfoReducer } from '@atredux/slices/zoneSlice'
import * as ZoneService from '@services/ZoneModule'

/**
 * Runs the ZoneService side effect AFTER the setZoneInfoReducer reducer has run.
 *
 * By calling next(action) first, the reducer completes before we invoke the side effect,
 * so the downstream store.getState() is safe. The reducer is now pure.
 */
export const zoneSideEffectMiddleware: Middleware = () => (next) => (action) => {
    const result = next(action)
    if (setZoneInfoReducer.match(action)) {
        try {
            ZoneService.setZoneInfo(action.payload.zone, action.payload.subzone)
        } catch (error) {
            // Isolate side-effect failure from the dispatcher; state was already updated by next(action).
            console.error('SMP: zoneSideEffectMiddleware failed to run ZoneService.setZoneInfo', error)
        }
    }
    return result
}
